var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.urlPath}},[(_vm.imgPath)?_c('LazyImage',{attrs:{"imageUrl":_vm.imgPath,"classes":['image-container--banner'],"alt":_vm.urlPath}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }